/**@jsxImportSource theme-ui */
import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Flex, Text } from 'theme-ui'

type Crumb = {
  label?: string
  link?: string
}

type BreadcrumbProps = {
  crumbs?: Array<Crumb>
}

const Breadcrumb = (props: BreadcrumbProps) => {
  const { crumbs = [] } = props

  return (
    <Flex as="ul" sx={{ variant: 'breadcrumbs.ul' }}>
      {crumbs.map((crumb: Crumb, idx: number) => {
        const check = crumbs.length - 1 === idx

        return (
          <Box key={idx} as="li" sx={{ variant: 'breadcrumbs.li' }}>
            {check ? (
              <Text color="secondary">{crumb.label}</Text>
            ) : (
              <Link sx={{ variant: 'breadcrumbs.breadcrumb' }} to={crumb.link}>
                {crumb.label}
              </Link>
            )}
          </Box>
        )
      })}
    </Flex>
  )
}

export default Breadcrumb
